/**
 * La barra anclada al piso del asistente, como el wizard de Activa: «Atrás» chico y el botón del paso (`CtaPaso`). Con el
 * botón apagado, debajo dice por qué. Debajo puede ir una línea más (`pie`: la del cobro en «Revisar y mandar») y arriba,
 * en el celular, la de «Tu campaña» (`resumen`), que en la computadora va en la columna de la derecha. El motivo va
 * asociado al botón (`aria-describedby`): un lector de pantalla dice por qué está apagado.
 */
import { useId, type ReactNode } from "react";
import { ArrowLeft, Loader2, Send } from "lucide-react";
import type { CtaPaso } from "../../logic/asistente";

export function BarraDelPaso({ cta, onAtras, primero, ocupado, envio, confirmando, pie, resumen }: {
  cta: CtaPaso;
  onAtras: () => void;
  /** el primer paso: «Atrás» vuelve a las campañas */
  primero: boolean;
  /** se está guardando o confirmando: el botón gira */
  ocupado: boolean;
  /** el botón manda la campaña («Revisar y mandar»): más alto y con el avión, salvo mientras confirma */
  envio: boolean; confirmando: boolean;
  pie?: ReactNode; resumen?: ReactNode;
}) {
  const apagado = cta.motivo !== null || !!cta.guardando;
  const idMotivo = useId();
  const conMotivo = apagado && !!cta.motivo;
  return (
    // en la computadora va en la columna del paso, al lado de «Tu campaña»: sin desbordar hacia los costados
    <div className="sticky bottom-0 z-20 -mx-6 md:-mx-8 lg:mx-0 lg:rounded-2xl lg:border border-t border-slate-200/80 bg-white/90 backdrop-blur-md px-6 md:px-8 lg:px-5 py-3 shadow-[0_-4px_24px_-12px_rgba(15,23,42,0.18)]">
      {resumen}
      <div className="flex items-center gap-2.5">
        <button type="button" onClick={onAtras} aria-label={primero ? "Volver a las campañas" : "Volver al paso anterior"}
          className="h-11 w-11 flex-shrink-0 rounded-xl border border-slate-200 bg-white text-slate-500 hover:bg-slate-50 inline-flex items-center justify-center">
          <ArrowLeft size={17} />
        </button>
        <div className="flex-1 min-w-0">
          <button
            type="button"
            onClick={() => void cta.onSiguiente()}
            disabled={apagado}
            aria-describedby={conMotivo ? idMotivo : undefined}
            className={`w-full rounded-xl bg-violet-600 text-white font-semibold hover:bg-violet-700 disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2 ${envio ? "h-12 text-base" : "h-11 text-sm"}`}
          >
            {ocupado && <Loader2 size={15} className="animate-spin" />}
            {envio && !confirmando && <Send size={15} />}
            {cta.label ?? "Siguiente"}
          </button>
          {conMotivo && <p id={idMotivo} className="mt-1 text-center text-[11px] text-slate-500">{cta.motivo}</p>}
          {pie}
        </div>
      </div>
    </div>
  );
}
